<section>
    <div class="form-container" fxFlex.lg="50" fxFlex.xs="100">
        <ng-content></ng-content>
    </div>
</section>
